const SERVER_URL = window.location.href.includes('localhost')
            ? `http://localhost:4000`
            : `https://ultimate-wishlist-server.vercel.app`
            
export { SERVER_URL }